<div class="shared-result-page">
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
                <div class="mb-4 text-center">
                    <h2 class="mb-2">Rezultat medical partajat</h2>
                    <p class="text-muted mb-0">
                        Vizualizați detaliile analizelor și investigațiilor medicale.
                    </p>
                </div>

                <div *ngIf="loading" class="card shadow-sm border-0">
                    <div class="card-body text-center py-5">
                        <div class="spinner-border text-success mb-3"></div>
                        <div class="text-muted">{{ message }}</div>
                    </div>
                </div>

                <div *ngIf="!loading && message && !selectedResult" class="alert alert-danger text-center">
                    {{ message }}
                </div>

                <div *ngIf="!loading && selectedResult" class="card dashboard-card results-card mb-4">
                    <div class="card-header text-white">
                        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h5 class="mb-1">Detalii rezultat</h5>
                                <small>
                                    {{ selectedResult.date | date:'dd.MM.yyyy' }}
                                </small>
                            </div>
                            <span
                                class="badge"
                                [ngClass]="selectedResult.status ? 'bg-success' : 'bg-danger'"
                            >
                                {{ getStatusLabel(selectedResult.status) }}
                            </span>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-12">
                                <h6>Analiza efectuată</h6>
                                <p class="summary">
                                    {{ selectedResult.analysisType }}
                                    <small>
                                        Data:
                                        {{ selectedResult.date | date:'dd.MM.yyyy' }}
                                        · Doctor:
                                        {{ selectedResult.doctorName || '-' }}
                                        · Specialitate:
                                        {{ selectedResult.senderSpecialisation || '-' }}
                                    </small>
                                </p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-4">
                                <div class="info-label">Pacient</div>
                                <div class="info-value">
                                    {{ getPatientName() }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info-label">Unitate medicală</div>
                                <div class="info-value">
                                    {{ getHospitalName() }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info-label">Status</div>
                                <div class="info-value">
                                    <span
                                        class="badge"
                                        [ngClass]="selectedResult.status ? 'bg-success' : 'bg-danger'"
                                    >
                                        {{ getStatusLabel(selectedResult.status) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div
                            *ngIf="
                                selectedResult.resultGroupList &&
                                selectedResult.resultGroupList.length > 0
                            "
                        >
                            <h6 class="section-subtitle mb-3">
                                Detalii analize medicale
                            </h6>

                            <div
                                class="container-fluid tabel-analize"
                                *ngFor="let group of selectedResult.resultGroupList"
                            >
                                <div
                                    class="row"
                                    *ngFor="let item of group.resultItemList"
                                    [ngClass]="item.normal ? '' : 'warn'"
                                >
                                    <div class="col-md-6">
                                        <strong>{{ item.labelForItem || item.code }}</strong>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        {{ item.stringValue || '-' }}
                                        <small class="text-muted">
                                            {{ item.measureUnit || '-' }}
                                        </small>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        {{ item.referenceValue || '-' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            *ngIf="
                                !selectedResult.resultGroupList ||
                                selectedResult.resultGroupList.length === 0
                            "
                            class="text-center text-muted py-4"
                        >
                            <i class="bx bx-info-circle" style="font-size: 2rem"></i>
                            <p class="mt-2">
                                Nu există detalii disponibile pentru acest rezultat.
                            </p>
                        </div>

                      
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>